/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Sync_Changes_From_Linked_GroupInputs */



/**
* | output |
* | --- |
* | "Sync Changes From Linked Group" |
*
* @param {Event_Group_Options_Sync_Changes_From_Linked_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_sync_changes_from_linked_group = /** @type {((inputs?: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Sync_Changes_From_Linked_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchroniser les modifications du groupe lié")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen aus verknüpfter Gruppe synchronisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizza le modifiche dal gruppo collegato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Синхронизация изменений из связанной группы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronizar cambios desde un grupo vinculado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("同步链接组的更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リンクされたグループからの変更を同期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लिंक किए गए समूह से परिवर्तनों को सिंक्रनाइज़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronizar alterações do grupo vinculado")
	return /** @type {LocalizedString} */ ("Sync Changes From Linked Group")
});